module.exports = __webpack_public_path__ + "static/img/description-raan-phasing.152646b.png";